// Anything below 650px will trigger mobile mode
export const MOBILE_MODE_WIDTH_THRESHOLD = 650;

export const TABLET_WIDTH_THRESHOLD = 768;

export const SMALL_DESKTOP_WIDTH_THRESHOLD = 1280;

export const onSmallDesktopDown = (availableWidth: number, cssRules: string): string =>
	availableWidth < SMALL_DESKTOP_WIDTH_THRESHOLD ? cssRules : '';

export const onTabletDown = (availableWidth: number, cssRules: string): string =>
	availableWidth <= TABLET_WIDTH_THRESHOLD ? cssRules : '';

export const onDesktop = (availableWidth: number, cssRules: string): string =>
	availableWidth > MOBILE_MODE_WIDTH_THRESHOLD ? cssRules : '';

export const onMobile = (availableWidth: number, cssRules: string): string =>
	availableWidth <= MOBILE_MODE_WIDTH_THRESHOLD ? cssRules : '';

// Completely hide element that's applied with this on mobile mode
export const hideOnMobile = (availableWidth: number): string =>
	onMobile(availableWidth, 'display: none;');

// Completely hide element that's applied with this on desktop mode
export const hideOnDesktop = (availableWidth: number): string =>
	onDesktop(availableWidth, 'display: none;');
